export default __webpack_public_path__ + "static/SharpGroteskBoldItalic15-Regular-4d487fb1d0daaddb2fbe80086050322e.woff2";